import apiReq from '../commontools/api.js'
import comfun from '../commontools/CommonFun.js'
export function GetOrderCusByOrder(OrderID) {

	var url='/CusInfo/GetOrderCusByOrder/'+OrderID;
	return apiReq.get(url)
}
export function GetOrderCusByExcel(f)
{
	var url='/ShowFile/GetOrderCusByExcel';
	return apiReq.post(url,f);
}
export function CheckCusAndGrp(cusent,groupent)
{
	
	let errm='';
	let sex=cusent.cussex;
	if(groupent.Sex!='3'&& sex!=groupent.Sex)
	{
		errm+='性别与分组不符；';
	}
	if(cusent.cusbirthday=='')
	{
		errm+='出生日期未填写；';
	}
	else
	{
		let age=comfun.BirthdayToAge(cusent.cusbirthday)
		if(age>groupent.MaxAge||age<groupent.MinAge)
	{
		errm+='年龄不在分组限制范围内；';
	}
	}
	
	let marry=cusent.cusmarry;
	if(groupent.Marry!='3'&& marry!=groupent.Marry)
	{
		errm+='婚否与分组不符（请确定已婚或未婚）；';
	}
	return  errm;
}
export function CheckErr(cuslist,ordergrouplist)
{
	for(let i=0;i<cuslist.length;i++)
	{
		cuslist[i].err='';
		var groupent= ordergrouplist.find(f=>f.GroupName==cuslist[i].groupname);
		if(groupent==null)
		{
			cuslist[i].errm+='分组名称不对；';
		}
		else
		{
			let sex='';
			if(cuslist[i].cussex=='男')
			sex='1';
			if(cuslist[i].cussex=='女')
			sex='2';
			if(sex=='')
			{
				cuslist[i].errm+='性别是必填项；';
			}
			if(groupent.Sex!='3'&& sex!=groupent.Sex)
			{
				cuslist[i].errm+='性别与分组不符；';
			}
			if(cuslist[i].cusbirthday=='')
			{
				cuslist[i].errm+='出生日期未填写；';
			}
			else
			{
				if(cuslist[i].cusage>groupent.MaxAge||cuslist[i].cusage<groupent.MinAge)
			{
				cuslist[i].errm+='年龄不在分组限制范围内；';
			}
			}
			
			let marry='';
			if(cuslist[i].cusmarry=='已婚')
			marry='1';
			if(cuslist[i].cusmarry=='未婚')
			marry='2';
			if(groupent.Marry!='3'&& marry!=groupent.Marry)
			{
				cuslist[i].errm+='婚否与分组不符（请确定已婚或未婚）；';
			}
			if(cuslist[i].mobile.length!='11')
			{
				cuslist[i].err+='手机号位数不对；';
			}
			if(cuslist[i].idcard.length!=15&&cuslist[i].idcard.length!=18)
			{
				cuslist[i].err+='身份证号长度不对；';
			}
		}
	}
	cuslist.sort((a,b)=>{return a.errm<b.errm;});
	return cuslist;
}
export function AddCus(info){
	var url='/CusInfo/AddCus';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function EditCus(info){
	var url='/CusInfo/EditCus';
	var p = {
		data: info
	}
	return apiReq.post(url, p);
}
export function DelCus(id) {
	var url='/CusInfo/DelCus/'+id;
	return apiReq.get(url)
}
export function ExportOrderCusToExcel(orderid){
	var url='/ShowFile/ExportOrderCusToExcel/'+orderid;
	return apiReq.defaults.baseURL+url;
}
export function GetCusForWaitBook(mobile){
	var url='/CusInfo/GetCusForWaitBook/'+mobile;
	return apiReq.get(url)
}
export function GetCusForBooked(mobile){
	var url='/CusInfo/GetCusForBooked/'+mobile;
	return apiReq.get(url)
}
export function SaveCusGroupAddItems(salemodulesjson){
	var url='/CusInfo/SaveCusGroupAddItems';
	var p = {
		data: salemodulesjson
	}
	return apiReq.post(url,p);
}
export function UpdateCusStatus(id,cusstatus){
	var url='/CusInfo/UpdateCusStatus/'+id+'/'+cusstatus;
	return apiReq.get(url)
}
export function UpdateCusGroupID(id,groupid){
	var url='/CusInfo/UpdateCusGroupID/'+id+'/'+groupid;
	return apiReq.get(url)
}
export function GetCusItemsByCusID(id){
	var url='/CusInfo/GetCusItemsByCusID/'+id;
	return apiReq.get(url)
}
export function GetCusItemsNopay(id){
	var url='/CusInfo/GetCusItemsNopay/'+id;
	return apiReq.get(url)
}

export function ProOrderCusPay(CorpID, cusid,  ChargeCash){
	var url='/CusInfo/ProOrderCusPay/'+CorpID+'/'+cusid+'/'+ChargeCash;
	return apiReq.get(url)
}
export function OrderCusPay(orderid){
	var url='/CusInfo/OrderCusPay';
	var p = {
		data:{
			out_trade_no: orderid
		}
	}
	return apiReq.post(url,p);
}
export function RefundOrderCusPay(cusid){
	var url='/CusInfo/RefundOrderCusPay/'+cusid;
	return apiReq.get(url)
}
export function RefundOrderCusPaySuccess(ordid){
	var url='/CusInfo/RefundOrderCusPaySuccess/'+ordid;
	return apiReq.get(url)
}
export function SaveSingleCusItems(id){
	var url='/CusInfo/SaveSingleCusItems/'+id;
	return apiReq.get(url)
}
export function GetCusForBookedDetail(mobile){
	var url='/CusInfo/GetCusForBookedDetail/'+mobile;
	return apiReq.get(url)
}
export function GetOrderCusByCusID(cusid){
	var url='/CusInfo/GetOrderCusByCusID/'+cusid;
	return apiReq.get(url)
}
export function GetCusOrderPayByCusID(cusid,orderstatus){
	var url='/CusInfo/GetCusOrderPayByCusID/'+cusid+'/'+orderstatus;
	return apiReq.get(url)
}
export function GetBookDetailByOrderID(orderid){
	var url='/CusInfo/GetBookDetailByOrderID/'+orderid;
	return apiReq.get(url)
}

export default{
	GetOrderCusByOrder,
	GetOrderCusByExcel,
	CheckErr,
	CheckCusAndGrp,
	AddCus,
	EditCus,
	DelCus,
	ExportOrderCusToExcel,
	GetCusForWaitBook,
	GetCusForBooked,
	SaveCusGroupAddItems,
	UpdateCusStatus,
	UpdateCusGroupID,
	GetCusItemsByCusID,
	ProOrderCusPay,
	OrderCusPay,
	RefundOrderCusPay,
	RefundOrderCusPaySuccess,
	SaveSingleCusItems,
	GetCusForBookedDetail,
	GetOrderCusByCusID,
	GetCusOrderPayByCusID,
	GetBookDetailByOrderID
}